import {useCurrentUserState} from 'app/current-user/api';

import type {GenericAcceptableDocument} from './types';
import type {AcceptanceSerializedType} from 'sweet-types';

export function isUserAcceptancePending<T extends GenericAcceptableDocument>(
  document?: T,
  acceptance?: AcceptanceSerializedType
): boolean {
  const currentUserId = useCurrentUserState().data!.id;
  return document != null && acceptance != null
    ? acceptance.object_id < document.current_version.id
      ? false // acceptance attached version was approved
      : acceptance.object_id === document.current_version.id &&
        document.approved_at !== null
      ? false // you are not assigned or already confirmed
      : acceptance.accept_statuses.filter(
          (s) => s.status == null && s.user.id === currentUserId
        ).length > 0
    : false;
}
